<!-- Passthrough wrapper – Inhalt liegt in ueber-uns/index.vue, team.vue, community.vue -->
<template>
  <NuxtPage />
</template>
